import Button from "lib/ui/controls/Button";
import { observe } from "../../../lib/reactive";
export class SmallImageButton extends Button {
    constructor(container = null) {
        super(container);
        if (!container) {
            this.container.addClass("nissmallimagebutton");
            this.append(c("<img>"));
        }
    }
    setEnabled(enabled) {
        super.setEnabled(enabled);
        if (enabled)
            this.container.removeClass("disabled");
        else
            this.container.addClass("disabled");
        return this;
    }
    setIcon(icon) {
        this.container.children("img").attr("src", icon);
        return this;
    }
    static new(icon) {
        return new SmallImageButton().setIcon(icon);
    }
}
export class SmallImageToggleButton extends SmallImageButton {
    constructor() {
        super();
        this.value = observe(false);
        this.addClass("nisl-small-image-toggle");
        this.onClick(() => {
            this.value.set(!this.value.value());
        });
        this.value.subscribe((v) => {
            this.toggleClass("active", v);
        });
    }
    setState(v) {
        this.value.set(v);
        return this;
    }
}
(function (SmallImageButton) {
    function sibut(icon, handler) {
        let but = new SmallImageButton().setIcon(icon);
        if (handler)
            but.onClick(handler);
        return but;
    }
    SmallImageButton.sibut = sibut;
    function sitog(icon, handler) {
        let but = new SmallImageToggleButton().setIcon(icon);
        if (handler)
            but.value.subscribe(handler);
        return but;
    }
    SmallImageButton.sitog = sitog;
})(SmallImageButton || (SmallImageButton = {}));
